import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";

import { BackednResponse, IGetFaectValue } from "@shared/lib/types";
import {
  IAgencyInfluencerRequestFacets,
  IInfluencerFacets,
} from "@shared/lib/types/influencer";
import { InfluencerService } from "../lib/services/manage.influencer.requests.service";
import { INFLUENCER_REQUEST_FACETS } from "../lib/constants";

export function useGetInfluencerRequestFacets() {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IAgencyInfluencerRequestFacets>
  >({
    queryKey: [...INFLUENCER_REQUEST_FACETS],
    queryFn: () => InfluencerService.getFacets(),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data || {},
    isError,
    isFetching: isLoading,
  };
}
